<template>
  <div class="modal" v-if="forceReload" style="z-index: 99999999">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Tambah Kegiatan Usaha Utama</h4>
        </div>
        <div class="kbli-modal-filter-search" style="padding: 0 10px">
          <form v-on:submit.prevent="noop">
            <div class="input-search">
              <b-input-group>
                <template #append>
                  <b-input-group-text>
                    <strong>
                      <i class="fas fa-times" style="cursor:pointer; marginRight: 10px" @click="resetPlaceholder()"
                        v-if="subSearch.length !== '' && subSearch"></i>
                      <i class="fas fa-search" style="cursor:pointer"></i>
                    </strong>
                  </b-input-group-text>
                </template>
                <b-form-input type="text" placeholder="Cari Usaha" v-model="subSearch"
                  @keyup="searchRun()"></b-form-input>
              </b-input-group>
            </div>
          </form>
        </div>
        <div class="modal-body" v-if="kbliData">
          <div class="horizontal">
            <div class="column5"></div>
            <div class="column10">Kode</div>
            <div class="column30 mr10">Keterangan</div>
          </div>
          <div class="horizontal" v-for="(item, index) in kbli" :key="index">
            <div class="column5">
              <input class="modal-input-checkbox" type="checkbox" :id="index" :value="item" v-model="choose" />
            </div>
            <div class="column10">{{ item.kode }}</div>
            <div class="column90 col-nohover mr10">{{ item.desc }}</div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="add()">
            Done
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      kbli: [],
      subKbliMaster: [],
      choosedKbli: [],
      subSearch: '',
      delKbli: [],
      addKbli: [],
      forceReload: true,
    }
  },
  computed: {
    choose: {
      get: function () {
        return this.$store.state.searchStore.choosedKbli
      },
      set(newValue) {
        this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'choosedKbli',
          value: newValue,
        })
      },
    },
    kbliData: function () {
      return this.setUpData()
    },
  },
  methods: {
    async add() {
      await this.closeModal()
    },
    async searchRun(id) {
      const search = String(this.subSearch)
      const list = this.subKbliMaster

      let filteredList = []
      for (let i in list) {
        if (list[i].desc.toLowerCase().indexOf(search.toLowerCase()) != -1) {
          filteredList.push(list[i])
        }
      }

      this.kbli = filteredList
    },
    resetPlaceholder() {
      this.subSearch = ''
      this.subKbli = this.subKbliMaster
    },
    async setUpData() {
      await this.$store.commit('modalStore/SET_GLOBAL_LOADING', true)
      const getKbli = await this.$getKbli()
      const defaultKbli = await this.$store.state.level1.choosedKbli

      let reduceKbli = await getKbli.reduce(
        (a, b) => ({ ...a, [b.kode]: b }),
        {}
      )

      let reduceDefault =
        (await defaultKbli) &&
        defaultKbli.reduce((a, b) => ({ ...a, [b.kode]: b }), {})

      let combine = { ...reduceKbli, ...reduceDefault }

      let newKbli = await Object.values(combine)

      this.kbli = await newKbli.sort((a, b) => this.$sortAsc(a, b))
      this.subKbliMaster = newKbli.sort((a, b) => this.$sortAsc(a, b))
      this.choosedKbli = await defaultKbli.map(list => {
        return list.id
      })

      await this.$store.commit('modalStore/SET_GLOBAL_LOADING', false)
    },
    async closeModal() {
      this.$store.commit('addEdit/ADD_EDIT_MODAL', {
        name: 'addKbli',
        status: false,
      })
    },
  },
}
</script>
<style scoped>
.modal {
  width: 100vw;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  display: block;
  overflow: hidden;
  outline: 0;
  background-color: rgba(0, 0, 0, 0.6);
}

.modal-dialog {
  width: 100vw;
  height: 100%;
}

.modal-content {
  width: 50vw;
  position: absolute;
  left: 50%;
  top: 30%;
  transform: translate(-50%, -30%);
}

.modal-body {
  height: 50vh;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.modal-input-checkbox {
  margin-right: 20px;
}
</style>
